import React, { useState } from 'react';
import css from './cappa-components.module.css';
import { FormattedMessage } from 'react-intl';
import { Button, SecondaryButton } from '../../../components';
import Icon from '../../../components/Icon/Icon';

const LandingHowItWorksSection = () => {
  const [tab, setTab] = useState('parent');

  const setTabParent = () => {
    setTab('parent');
  };

  const setTabCareProvider = () => {
    setTab('care-provider');
  };

  const parentButtonText = (
    <FormattedMessage
      id="LandingPage.cappaComponents.howItWorksHeaderTabsButtonsParent"
      defaultMessage="Parent"
    />
  );

  const careProviderButtonText = (
    <FormattedMessage
      id="LandingPage.cappaComponents.howItWorksHeaderTabsButtonsCareProvider"
      defaultMessage="Care Provider"
    />
  );

  return (
    <div className={css.howItWorksRoot}>
      <div className={css.howItWorksHeader}>
        <div className={css.howItWorksHeaderText}>
          <div className={css.howItWorksHeaderTitle}>
            <FormattedMessage
              id="LandingPage.cappaComponents.howItWorksHeaderTitle"
              defaultMessage="How it works?"
            />
          </div>
          <div className={css.howItWorksHeaderDescription}>
            <FormattedMessage
              id="LandingPage.cappaComponents.howItWorksHeaderDescription"
              defaultMessage="Easily connect with the right care proffesional or grow your practice as a care provider. Follow these simple steps to get started."
            />
          </div>
        </div>
        <div className={css.howItWorksHeaderTabsButtons}>
          {tab === 'parent' ? (
            <Button onClick={setTabParent}>{parentButtonText}</Button>
          ) : (
            <SecondaryButton onClick={setTabParent}>{parentButtonText}</SecondaryButton>
          )}
          {tab === 'parent' ? (
            <SecondaryButton onClick={setTabCareProvider}>{careProviderButtonText}</SecondaryButton>
          ) : (
            <Button onClick={setTabCareProvider}>{careProviderButtonText}</Button>
          )}
        </div>
      </div>
      <div className={css.howItWorksContent}>
        {tab === 'parent' ? <ParentCards /> : <CareProviderCards />}
      </div>
    </div>
  );
};

const ParentCards = () => {
  const findTheRightProfessionalText = (
    <FormattedMessage
      id="LandingPage.cappaComponents.howItWorks.parent1Title"
      defaultMessage="Find the right proffesional for you"
    />
  );
  const findTheRightProfessionalDescriptionText = (
    <FormattedMessage
      id="LandingPage.cappaComponents.howItWorks.parent1Description"
      defaultMessage="Use our search and filters to explore experienced care proffeionals in your area. Compare services, read reviews, and find the perfect match for your needs."
    />
  );
  const createAnAccountText = (
    <FormattedMessage
      id="LandingPage.cappaComponents.howItWorks.parent2Title"
      defaultMessage="Create an account"
    />
  );
  const createAnAccountDescriptionText = (
    <FormattedMessage
      id="LandingPage.cappaComponents.howItWorks.parent2Description"
      defaultMessage="Sign up for free to access detailed care proffesionals profiles, save your favorites, and connect with potential matches effortlessly."
    />
  );
  const getInTouchText = (
    <FormattedMessage
      id="LandingPage.cappaComponents.howItWorks.parent3Title"
      defaultMessage="Get in touch"
    />
  );
  const getInTouchDescriptionText = (
    <FormattedMessage
      id="LandingPage.cappaComponents.howItWorks.parent3Description"
      defaultMessage="Reach out to your chosen care proffesional, ask questions, and schedule a consultation to ensure the perfect fit for your journey."
    />
  );
  return (
    <div className={css.howItWorksContent}>
      <Card
        icon={<Icon icon="BigMagnifyingGlass" size={70} />}
        title={findTheRightProfessionalText}
        description={findTheRightProfessionalDescriptionText}
        index={1}
      />
      <Card
        icon={<Icon icon="BigPlus" size={70} />}
        title={createAnAccountText}
        description={createAnAccountDescriptionText}
        index={2}
      />
      <Card
        icon={<Icon icon="BigChat" size={70} />}
        title={getInTouchText}
        description={getInTouchDescriptionText}
        index={3}
      />
    </div>
  );
};

const CareProviderCards = () => {
  const careProvider1TitleText = (
    <FormattedMessage
      id="LandingPage.cappaComponents.joinOurCommunity.careProvider1Title"
      defaultMessage="Join Our Community"
    />
  );
  const careProvider1DescriptionText = (
    <FormattedMessage
      id="LandingPage.cappaComponents.joinOurCommunity.careProvider1Description"
      defaultMessage="Sign up for free and become part of a trusted network of professional care providers. Create an account in just a few minutes and start connecting with parents seeking support."
    />
  );
  const careProvider2TitleText = (
    <FormattedMessage
      id="LandingPage.cappaComponents.buildYourProfile.careProvider2Title"
      defaultMessage="Build Your Profile"
    />
  );
  const careProvider2DescriptionText = (
    <FormattedMessage
      id="LandingPage.cappaComponents.buildYourProfile.careProvider2Description"
      defaultMessage="Sign up for free and become part of a trusted network of professional care providers. Create an account in just a few minutes and start connecting with parents seeking support."
    />
  );
  const careProvider3TitleText = (
    <FormattedMessage
      id="LandingPage.cappaComponents.connectWithClients.careProvider3Title"
      defaultMessage="Connect with Clients"
    />
  );
  const careProvider3DescriptionText = (
    <FormattedMessage
      id="LandingPage.cappaComponents.connectWithClients.careProvider3Description"
      defaultMessage="Receive inquiries from parents looking for a care proffesional. Communicate directly, answer their questions, and grow your client base with ease."
    />
  );
  return (
    <div className={css.howItWorksContent}>
      <Card
        icon={<Icon icon="BigPeople" size={70} />}
        title={careProvider1TitleText}
        description={careProvider1DescriptionText}
        index={1}
      />
      <Card
        icon={<Icon icon="BigDocument" size={70} />}
        title={careProvider2TitleText}
        description={careProvider2DescriptionText}
        index={2}
      />
      <Card
        icon={<Icon icon="BigChat" size={70} />}
        title={careProvider3TitleText}
        description={careProvider3DescriptionText}
        index={3}
      />
    </div>
  );
};

const Card = ({ icon, title, description, index }) => {
  return (
    <div className={css.howItWorksContentCard}>
      <div className={css.topPart}>
        <div className={css.topPartIndex}>{index}</div>
        <div className={css.topPartIcon}>{icon}</div>
      </div>
      <div className={css.bottomPart}>
        <div className={css.bottomPartTitle}>{title}</div>
        <div className={css.bottomPartDescription}>{description}</div>
      </div>
    </div>
  );
};

export default LandingHowItWorksSection;
